module.exports = require("text-encoding-utf-8");


//////////////////
// WEBPACK FOOTER
// external "text-encoding-utf-8"
// module id = 19
// module chunks = 0 1